import { render } from "./SmsCodeInput.vue?vue&type=template&id=895e98e0&scoped=true"
import script from "./SmsCodeInput.vue?vue&type=script&lang=js"
export * from "./SmsCodeInput.vue?vue&type=script&lang=js"

import "./SmsCodeInput.vue?vue&type=style&index=0&id=895e98e0&lang=less&scoped=true"

import exportComponent from "D:\\workday\\code\\h5-moxigecash\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-895e98e0"]])

export default __exports__